"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dashboard;

var _react = _interopRequireDefault(require("react"));

var _clientAuth = require("@devsta/client-auth");

var _uiKit = require("@devsta/ui-kit");

var _reactRouterDom = require("react-router-dom");

var _VideoList = _interopRequireDefault(require("../../../common/components/VideoList"));

require("../styles/_video-dashboard.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Dashboard(_ref) {
  var organisationName = _ref.organisationName;
  return (/*#__PURE__*/_react.default.createElement(_VideoList.default, {
      summaryTitle: "Welcome back, ".concat(_clientAuth.credentials.get().user.firstName, "!"),
      summarySubtitle: "Here are your videos for today.",
      headerSubtitle: organisationName,
      headerTitle: "Video Dashboard",
      summaryCards: [{
        label: 'EDITING IN-PROGRESS',
        status: ['EDITING', 'INTERNAL_REVIEW']
      }, {
        label: 'PENDING REVIEW',
        status: 'PENDING_REVIEW'
      }, {
        label: 'ON-HOLD',
        status: 'ON_HOLD'
      }],
      headerSecondaryContent: /*#__PURE__*/_react.default.createElement("div", {
        className: "video-dashboard__manage-projects"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "folder",
        color: "russian",
        size: 20
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: "/video-tool/projects"
      }, "MANAGE PROJECTS"))
    })
  );
}